<template>
    <nav class="w-full flex flex-wrap justify-between items-center bg-blue-900 rounded-none">
        <div class=" w-full flex justify-between items-center py-4 px-2 md:px-4">
            <Logo></Logo>
            <div class="ml-4 flex flex-grow items-center justify-end">
                <div class="flex-grow max-w-md">
                    <Search></Search>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
    import Logo from "./Logo.vue";
    import Search from "./Search.vue";

    export default {
        name: "DefaultHeader",
        components: {
            Logo,
            Search
        },
    };
</script>